import { Component, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { WorkflowService } from '../services/workflow-service';
import { GlobalService } from '../services/global.service';
import { AlertComponent } from '../common/alert/alert.component';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterFieldTypes } from '../shared/common-constants';
import { WorkflowReportComponent } from '../common/workflow-report/workflow-report.component';
import { EventModel } from '../models/workflow-report/workflow-event.model';
import { NavigationEnd, Router, RouterEvent, ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { TenantService } from '../services/tenant.service';


@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.css']
})
export class workflowComponent implements OnDestroy {
  resourceList: any = [];
  expandedIndex: any;
  isLoading = true;
  modelErrorMessage = 'Error';
  modelDetails: any;
  workflowListDetails: MatTableDataSource<any>;
  displayedColumns: string[] = ['status', 'workflowName', 'workflowDescription', 'workflowId', 'lastRun', 'lastUpdatedBy', 'Action'];
  isLinear = false;
  workflowIdToDelete: number = 0;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  statusOption = ['Active', 'Inactive'];
  workflowStatus = '';
  workflowToChangeStatus;
  indexOfWorkflow;
  subscription;
  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;
  searchText: string = "";
  public destroyed = new Subject<any>();
  constructor(
    public tenantService: TenantService,
    public globals: GlobalService,
    public workflowService: WorkflowService,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog) {
    const emptyList: any[] = [];
    this.workflowListDetails = new MatTableDataSource(emptyList);
    if (!this.subscription) {
      this.subscription = this.router.events.pipe(
        filter((event: any) => event instanceof NavigationEnd),
        takeUntil(this.destroyed)
      ).subscribe(() => {
        this.initialize();
      });
    }

  }

  initialize() {
    this.expandedIndex = -1;
    let serviceTenant:any = this.tenantService.getCurrentTenant();

    if (serviceTenant?.tenantId && serviceTenant.tenantId > 0) {
      this.workflowService.getToken().subscribe((data: any): void => {      
        this.isLoading = true;
        let workFlowList = this.getWorkflowList();
        let workFlowDetails = this.getWorkflowDetails();
        forkJoin([workFlowList, workFlowDetails]);
      });
    }    
  }

  getWorkflowDetails() {
    this.route.params.subscribe((params: any) => {
      if (!this.globals.isNotNull(params.id) && this.globals.isNotNull(params.workflowName)) {
        this.searchText = params.workflowName;
      } else if (this.globals.isNotNull(params.id) && this.globals.isNotNull(params.workflowName)) {
        this.loadReport(params.id, params.workflowName);
      }
    });
  }

  

  getWorkflowList() {
    this.selectedFilters = [];
    this.workflowService.getWorkflowList().subscribe((data: any): void => {
      if (data && data !== null && data.length > 0) {
        this.masterData = [...data];
        this.workflowListDetails = new MatTableDataSource(data);
        this.workflowListDetails.sort = this.sort;
        this.workflowListDetails.paginator = this.paginator;
        if (this.globals.isNotNull(this.searchText)) {
          this.applyFilter(this.searchText);
        }
      }
      else {
        this.workflowListDetails.data = [];
      }
      this.isLoading = false;
      this.filterList = [];
      this.createFilterList();
    }, (error: Error) => {

      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching Workflow List" });
      this.isLoading = false;
    });
  }

  deleteWorkflow(workflowId) {
    let status: string = this.masterData.find(element => element.workflowId == workflowId).status;
    if (status == 'Active') {
      this.globals.showAlert(AlertComponent, { success: false, message: "Disabled when a workflow is online." });
    } else {
      this.workflowIdToDelete = workflowId;
      let dataToPass = {
        title: 'Delete',
        isDelete: true,
        message: 'Do you really want to delete it?'
      };
      this.globals.openModelWindow(this.deleteOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
    }
  }

  deleteOnConfirm(thisRef: workflowComponent) {
    thisRef.isLoading = true;
    thisRef.workflowService.deleteWorkflow(thisRef.workflowIdToDelete).subscribe((result: any): void => {
      thisRef.getWorkflowList();
      thisRef.isLoading = false;
      thisRef.workflowIdToDelete = 0;
      thisRef.globals.showAlert(AlertComponent, { success: true, message: "Workflow deleted successfully!" });
    }, (error: Error) => {
      thisRef.globals.showAlert(AlertComponent, { success: false, message: "Error in deleting Workflow" });
      thisRef.isLoading = false;
      thisRef.workflowIdToDelete = 0;
    });
  }

  /**
   * get called on change of option in dropdown of status
   * @param element element
   * @param index index of workflow in list
   */
  onStatusChange(element, index) {
    this.indexOfWorkflow = index;
    this.workflowStatus = element.status;
    this.workflowToChangeStatus = element.workflowId;
    const dataToPass = {
      title: 'Change Status',
      isDelete: false,
      message: 'Do you really want to status to ' + element.status + '?'
    };
    this.globals.openModelWindow(this.changeStatusConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass, 'statusChange');
  }

  /**
   * checks result if it is confirmed on popup and proceeds
   * to call api and updates status on backend
   * @param thisRef reference to workflow component
   * @param result result coming from model component
   */
  changeStatusConfirm(thisRef: workflowComponent, result: boolean) {
    if (result) {
      thisRef.workflowService.updateWorflowStatus(thisRef.workflowToChangeStatus, thisRef.workflowStatus).subscribe((resultStatus) => {
        if (!resultStatus) {
          thisRef.resetDropdown(thisRef.workflowToChangeStatus);
        }
      }, (error: Error) => {
        thisRef.globals.showAlert(AlertComponent, { success: false, message: "Error in updating status of workflow" });
        thisRef.isLoading = false;
        thisRef.resetDropdown(thisRef.workflowToChangeStatus);
      });
    } else {
      thisRef.resetDropdown(thisRef.workflowToChangeStatus);
    }
  }


  /**
   * resets dropdown to its previous value in case of
   *  failure or cancel
   * @param workflowId  workflow id which is clicked
   */
  resetDropdown(workflowId) {
    if (workflowId) {
      const indexOfWorkflow = this.workflowListDetails.filteredData.findIndex(obj => obj.workflowId === workflowId);
      if (this.workflowListDetails.filteredData[indexOfWorkflow].status === this.statusOption[0]) {
        this.workflowListDetails.filteredData[indexOfWorkflow].status = this.statusOption[1];
      } else {
        this.workflowListDetails.filteredData[indexOfWorkflow].status = this.statusOption[0];
      }
    }
  }

  /**
    * Filters data based on input text
    * @param filterValue
    */
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase(); // Remove whitespace and MatTableDataSource defaults to lowercase matches
    this.workflowListDetails.filter = filterValue;
  }

  /**Creates data for filter list */
  createFilterList() {
    let columns: string[] = ['workflowName', 'workflowDescription', 'workflowId', 'lastRun', 'lastUpdatedBy'];
    for (let a = 0; a < columns.length; a++) {
      let tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldName = this.globals.replaceDisplayText(columns[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      if (columns[a] == "workflowName") {        
        unique = Array.from(new Set(this.workflowListDetails.data.map(a => a.workflowName)));
      } else if (columns[a] == "workflowDescription") {        
        unique = Array.from(new Set(this.workflowListDetails.data.map(a => a.workflowDescription)));
      } else if (columns[a] == "workflowId") {   
        tempFilter.fieldType = FilterFieldTypes.values;     
        unique = Array.from(new Set(this.workflowListDetails.data.map(a => a.workflowId)));
      } else if (columns[a] == "lastRun") {        
        unique = Array.from(new Set(this.workflowListDetails.data.map(a => a.lastRun)));
      } else if (columns[a] == "lastUpdatedBy") {        
        unique = Array.from(new Set(this.workflowListDetails.data.map(a => a.lastUpdatedBy)));
      }
      tempFilter.values = unique.sort((n1, n2) => n1 - n2);
      this.filterList.push(tempFilter);
    }
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    switch (filterResponse.selectedCondition) {
      case "==":
        this.workflowListDetails.data = this.workflowListDetails.data.filter(
          (df) => df[filterResponse.selectedFieldName] === filterResponse.selectedValue);
        break;
      case ">=":
        this.workflowListDetails.data = this.workflowListDetails.data.filter(
          (df) => df[filterResponse.selectedFieldName] >= parseInt(filterResponse.selectedValue, 10));
        break;
      case "<=":
        this.workflowListDetails.data = this.workflowListDetails.data.filter(
          (df) => df[filterResponse.selectedFieldName] <= parseInt(filterResponse.selectedValue, 10));
        break;
    }
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.workflowListDetails.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.workflowListDetails.data = this.globals.conditionalDataFiltering(element, this.workflowListDetails.data);

        }
      }
    }
  }

  /**
   * Loads the report for selected workflow
   * @param workflowId
   * @param workflowName
   */
  loadReport(workflowId: number, workflowName: string) {
    this.isLoading = true;
    this.workflowService.loadReportData(workflowId).subscribe((data: EventModel[]) => {
      if (data != undefined && data != null && data.length > 0) {        
        let dataToPass = { workflowId: workflowId, workflowName: workflowName, reportData: data };
        this.globals.openModelWindowWithoutCallBack(WorkflowReportComponent, '1000px', 'confirm-modalbox', dataToPass);
      } else {
        this.globals.showAlert(AlertComponent, { success: false, message: "No reports to show as the workflow never got triggered!" });
      }
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Something went wrong!" });
      this.isLoading = false;
    });
  }

  editWorkflow(element) {
    if (element.status == 'Active') {
      this.globals.showAlert(AlertComponent, { success: false, message: "Disabled when a workflow is online." });
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

}

